import { render } from "./ShowList.vue?vue&type=template&id=56567226&scoped=true"
import script from "./ShowList.vue?vue&type=script&lang=js"
export * from "./ShowList.vue?vue&type=script&lang=js"

import "./ShowList.vue?vue&type=style&index=0&id=56567226&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56567226"]])

export default __exports__